import React from 'react';
import Router from 'next/router';
import { connect } from 'react-redux';
import axios, { AxiosResponse } from 'axios';
import { TextInput } from '../../../modules/Inputs';
import { Button } from '../../../modules/Buttons';
import { ApplicationState } from '../../../types/state/storeTypes';
import { ENV } from '../../../constants/environments';
import Layout from '../../../layout/Layout';
import { AUTH_ACTIONS } from '../../../constants/actions';
class Reset extends React.Component<any> {
  constructor(props) {
    super(props);

    this.state = {
      errors: [],
      messages: []
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.render = this.render.bind(this);

    this.props.dispatch({ type: AUTH_ACTIONS.AUTH_HIDE_LOGIN });
  }

  private apiURL: string = `${ENV.api.baseURL}/users/password`;
  private redirectURL: string = `${ENV.authReturnTo}/users/reset/new`;

  async handleSubmit(event: React.FormEvent): Promise<void> {
    event.preventDefault();

    const formData: FormData = new FormData(event.target as HTMLFormElement);
    const email = formData.get('email');

    if (!email) return this.setState({ errors: ['Email must be provided'] });
    this.setState({ errors: [] });

    try {
      const res: AxiosResponse = await axios({
        method: 'POST',
        url: this.apiURL,
        data: {
          email,
          redirect_url: this.redirectURL
        }
      });
      this.setState({
        errors: [],
        messages: [res.data.message]
      });
    } catch {
      this.setState({
        errors: ['Invalid email'],
        messages: []
      });
    }
  }

  componentDidMount() {
    if (this.props.authenticated) Router.push('/');
  }

  render() {
    return (
      <Layout head={{ title: 'Forgot Password' }}>
        <div
          className="bg-gray-800 min-h-[500px] flex items-center justify-center"
          data-testid="resetPasswordContainer"
        >
          <div className="heading-container">
            <h1 className="uppercase text-[36px]">Forgot your password?</h1>
            <p className="py-3">
              Please enter your email to receive instructions to reset your password
            </p>
            <form className="form-container" onSubmit={this.handleSubmit}>
              <TextInput
                name="email"
                label="email"
                placeholder="Enter email"
                variant="email-input"
              />
              <Button
                type="submit"
                text={'Send Password Reset Instructions'}
                className="uppercase bg-a-blue rounded-[5px] px-6 pt-4 pb-5 text-[18px] eurostile font-semibold my-6"
              />

              {(this.state as any).errors.map((err) => (
                <p className="bg-red-800 rounded-[5px] text-white py-2 px-4 max-w-[500px]">{err}</p>
              ))}

              {(this.state as any).messages.map((err) => (
                <p className="bg-green-800 rounded-[5px] text-white py-2 px-4 max-w-[500px]">
                  {err}
                </p>
              ))}
            </form>
          </div>
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = (state: ApplicationState) => ({
  authenticated: state.auth.authenticated
});

export default connect(mapStateToProps)(Reset);
